import styled from 'styled-components'

import { Color, MediaBreakpoint } from 'root-constants'

export const StyledStepper = {
  Root: styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
  `,
  Checkpoint: styled.span<{ $isReached: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 16px;
    height: 16px;

    background-color: ${({ $isReached }) =>
      $isReached ? Color.GOLD_BASE : Color.WHITE};
    border-radius: 50%;
    transition: background-color 200ms ease-out;

    svg {
      flex-shrink: 0;
    }
  `,
  Segment: styled.span`
    display: block;
    flex: 1 0 auto;
    min-width: 40px;
    height: 2px;
    overflow: hidden;

    @media (max-width: ${MediaBreakpoint.MEDIUM_PHONE}px) {
      min-width: 28px;
    }

    background-color: ${Color.WHITE};
    border-radius: 4px;
  `,
  SegmentFill: styled.span<{ $fillDurationMs: number }>`
    display: block;
    height: 100%;

    background-color: ${Color.GOLD_BASE};
    border-radius: 4px;
    transition: width ${({ $fillDurationMs }) => $fillDurationMs}ms ease-out;
  `,
}
